import { Helmet } from 'react-helmet-async'

const Analytics = () => {
  return (
    <>
      <Helmet>
        <title>Analytics & Report - LIFT</title>
      </Helmet>
      <h1>Analytics & Report</h1>
    </>
  )
}

export default Analytics
